(ns common.schema.entities.workspace.kyc.questions.board-member
  (:require
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]))

(def board-roles
  [])

(def all-questions
  {:kyc-board-member/first-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "First name"
                       :fi "Etunimi"}}

   :kyc-board-member/middle-names
   {:data/type    :data.type/text-simple
    :translations {:en "Middle names"
                   :fi "Toiset nimet"}}

   :kyc-board-member/last-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Last name"
                       :fi "Sukunimi"}}

   :kyc-board-member/role
   {:data/type        :data.type/keyword
    :options          [{:key :board-member
                        :translations {:en "Board member"
                                       :fi "Hallituksen jäsen"}}
                       {:key :chair-of-the-board
                        :translations {:en "Chair of the board"
                                       :fi "Hallituksen puheenjohtaja"}}
                       {:key :deputy-board-member
                        :translations {:en "Deputy board member"
                                       :fi "Hallituksen varajäsen"}}]
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Role"
                       :fi "Rooli"}}

   :kyc-board-member/dob
   {:data/type        :data.type/date
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Date of birth"
                       :fi "Syntymäaika"}}

   :kyc-board-member/country
   {:data/type        :data.type/keyword
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Residence"
                       :fi "Asuinmaa"}}

   :kyc-board-member/nationalities
   {:data/type        :data.type/text-edn
    :edn-data/type    :edn-data.type/nationalities
    :options          country/options
    :mandatory-field? (fn [answers kyc-process]
                        (and (not= (:kyc-process/status kyc-process)
                                   :kyc-process.status/draft)
                             (kyc-utils/nationalities-unanswered?
                              answers
                              kyc-utils/board-member-nationality-keys)))
    :validation-fn    (fn [{:keys [answers kyc-process]}]
                        (when (and (not= (:kyc-process/status kyc-process)
                                         :kyc-process.status/draft)
                                   (kyc-utils/nationalities-missing-data?
                                    answers
                                    kyc-utils/board-member-nationality-keys))
                          :validation.error/nationality-and-national-id-required))
    :translations     {:en "Nationality"
                       :fi "Kansalaisuus"}}})
